import React from 'react';
import { createComponent } from '@lit/react';
import { IxLabelTag as LitComp } from '../IxLabelTag.js';

customElements.define('ix-label-tag', LitComp);

export const IxLabelTag = createComponent({
  tagName: 'ix-label-tag-react',
  elementClass: LitComp,
  react: React,
});
